import { render, staticRenderFns } from "./order-table.vue?vue&type=template&id=2d255b9c"
import script from "./order-table.vue?vue&type=script&lang=js"
export * from "./order-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports